// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2syF5","amount":"Amount_amount__2iK1N","tip":"Amount_tip__3T8ca","tipHeader":"Amount_tipHeader__34hjA","tipsWrap":"Amount_tipsWrap__3Evl_"};